import { render, staticRenderFns } from "./ShareProofModal.vue?vue&type=template&id=007bdef6"
import script from "./ShareProofModal.vue?vue&type=script&lang=js"
export * from "./ShareProofModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007bdef6')) {
      api.createRecord('007bdef6', component.options)
    } else {
      api.reload('007bdef6', component.options)
    }
    module.hot.accept("./ShareProofModal.vue?vue&type=template&id=007bdef6", function () {
      api.rerender('007bdef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/ShareProofModal.vue"
export default component.exports